import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  // Link
} from "react-router-dom";
// import logo from './logo.svg';
import withFirebaseAuth from 'react-with-firebase-auth'
import firebase from "./config/firebase"

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle';
import './App.css';
import './assets/css/styles.css';

import Upload from './containers/Upload';
import Login from './containers/Login';

class App extends Component {
  render() {

    const {
      user,
      // signOut,
      // signInWithGoogle,
    } = this.props;
    console.log(user)

    return (
      <div className="App">
        <Router>
          <Switch>
            {user ? (
              <Route exact path="/">
                <Upload />
              </Route>
            ) : (
                <Route exact path="/">
                  <Login {...this.props} />
                </Route>
              )}
            <Route exact path="/login">
              <Login {...this.props} />
            </Route>
            {(user || true) && (
              <Route path="/upload">
                <Upload />
              </Route>
            )}
            {/* <Route path="/dashboard">
              <Dashboard />
            </Route> */}
          </Switch>
        </Router>
      </div>
    );
  }
}


const firebaseAppAuth = firebase.auth();

const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider(),
};

export default withFirebaseAuth({
  firebaseAppAuth,
  providers,

})(App);
